import { strToElement } from "../frontendlib/dom_utils";

/** TODO(oscar): This is a temporary solution to add deadzones to CSPs. */
export const addDeadzoneStyles = () => {
  const el = strToElement(`
  <style>
    .liftoff-deadzone.deadzone-experiment {
      position: absolute;
      width: max(50px, min(85px, 11vw));
      height: max(50px, min(85px, 11vw));
      z-index: 96;
    }
    .liftoff-deadzone.top-left {
      top: 0;
      left: 0;
    }
    .liftoff-deadzone.top-right {
      top: 0;
      right: 0;
    }
  </style>
  `);
  document.head.appendChild(el);
};

const addDeadzones = (useExpandedZones, rootEl = document.body) => {
  const deadzoneEls = [
    strToElement(`<div class="liftoff-deadzone top-left"></div>`),
    strToElement(`<div class="liftoff-deadzone top-right"></div>`),
  ];
  deadzoneEls.forEach((el) => {
    if (useExpandedZones) {
      el.classList.add("deadzone-experiment");
    }
    rootEl.appendChild(el);
  });
};

export default addDeadzones;



// WEBPACK FOOTER //
// ./src/js/madlib/addDeadzones.js